export default __webpack_public_path__ + "static/media/cart.8f4fed9e.svg";